import { CustomPDPGallery } from '@theme/component-custom-pdp-gallery';
import '@theme/component-custom-pdp-variant-picker';
import { CustomPDPProductForm } from '@theme/component-custom-pdp-product-form';

// Register components
if (!customElements.get('custom-pdp-gallery')) {
  customElements.define('custom-pdp-gallery', CustomPDPGallery);
}

// variant-picker is registered in its own file

if (!customElements.get('custom-pdp-product-form')) {
  customElements.define('custom-pdp-product-form', CustomPDPProductForm);
}

// Handle theme editor events
if (window.Shopify?.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.custom-pdp-section');
    if (section) {
      // Components will auto-initialize via connectedCallback
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('.custom-pdp-section');
    if (section) {
      // Components will auto-cleanup via disconnectedCallback
    }
  });
}
